<template>
    <component :is="isList ? 'li' : 'div'" class="dealer-item">
        <h5>{{ dealer.translated.name }}</h5>
        <p>
            {{ dealer.address }}<br />
            {{ dealer.zipcode }} {{ dealer.city }}
        </p>
        <a v-if="dealer.website && isNL" :href="dealer.website" target="_blank" class="dealer_search_website">{{ dealer.website }}</a>
        <a v-if="dealer.email" :href="'mailto:' + dealer.email" class="dealer_search_email">{{ dealer.email }}</a>
        <a v-if="dealer.phone" :href="'tel:' + formattedPhone" class="dealer_search_phone">{{ dealer.phone }}</a>
        
        <div class="spacer"></div> <!-- small spacing -->

        <div class="meta" v-if="dealer.vakgebieden && isNL && isPro">
            <span class="vakgebied" v-for="vakgebied in dealer.vakgebieden.split(',')" :key="vakgebied">{{ vakgebied }}</span>
        </div>

        <div class="meta" v-if="(isNaturapy && !isProPath) || (isPremiumHobby && !isProPath) || (isProPremium && isProPath)">
            <span
                v-if="isNaturapy && !isProPath"
                class="meta-naturapy logo"
                v-tooltip="$t('dealers.meta_naturapy_label')"
            >
                {{ $t('dealers.meta_naturapy_label') }}
            </span>
            <span
                v-if="isPremiumHobby && !isProPath"
                class="meta-premium"
                :class="{ 'logo': isNL }"
                v-tooltip="isNL ? $t('dealers.meta_premium_label') : null"
            >
                {{ $t('dealers.meta_assortment_label') }}
            </span>
            <span
                v-if="isProPremium && isProPath"
                class="meta-premium"
                v-tooltip="isNL ? $t('dealers.meta_premium_label') : null"
            >
                {{ $t('dealers.meta_assortment_label') }} 
            </span>
        </div>
    </component>
</template>

<script>
import TooltipDirective from '../../directives/tooltip';

export default {
    props: {
        dealer: Object,
        isList: Boolean,
        segment: String        
    },

    directives: {
        tooltip: TooltipDirective
    },

    computed: {

        isPro(){
            return this.segment?.toLowerCase() == 'pro';
        },

        // True when the current page URL is on a /pro/ path (independent of the
        // segment data param). Matches a "pro" path segment, e.g. /pro, /pro/,
        // /be/pro/dealers, etc.
        isProPath() {
            return /(^|\/)pro(\/|$)/.test(window.location.pathname);
        },

        isNL() {
            return this.dealer.country == 'NL';
        },

        isNaturapy() {
            return (this.dealer.naturapy || this.dealer.naturapypickup);
        },

        isPremium() {
            return (this.dealer.premium || this.dealer.propremium) && !(this.isNL && this.isPro);
        },

        isPremiumHobby() {
            return (this.dealer.premium && !this.isPro);
        },

        isProPremium() {
            return (this.dealer.propremium && this.isPro);
        },

        isProPremiumNL() {
            return (this.dealer.propremium && this.isPro && this.isNL);
        },

        formattedPhone() {
            return this.dealer.phone?.replace(/[^0-9]/g, '');
        }
    }
};
</script>
